<template>
  <v-container fluid>
    <v-card-text>
      <h2 :style="'text-wrap: balance;' + isMobile() ? 'text-align: center' : ''" class="mb-2">
        {{ $t('common.label_clubNotFound') }}
      </h2>
      <v-row no-gutters class="flex-row" justify="center" align="center" style="gap: 32px">
        <v-card class="pa-2" style="text-align: center">
          <v-col>
            <h4>{{ $t('error.clubNumNotFound') }}</h4>
            <br />
            {{ $t('error.clubNumInfoLine1') }}
            <br />
            {{ $t('error.clubNumInfoLine2') }}
          </v-col>
          <v-row no-gutters align="center" justify="center" style="gap: 16px">
            <v-col cols="12" sm="3">
              <v-text-field v-model="clubNumToRetry" type="number" @keydown.enter="checkNewClubNum(clubNumToRetry)"
                :label="$t('common.label_clubNumber')" prepend-icon="mdi-town-hall" clearable />
            </v-col>

          </v-row>
          <v-btn color="primary" :loading="retryButtonLoading" @click="checkNewClubNum(clubNumToRetry)"
            :disabled="clubNumToRetry == undefined || clubNumToRetry <= 0">
            <v-icon> mdi mdi-reload-alert </v-icon>
            {{ $t('common.label_tryAgain') }}
          </v-btn>
        </v-card>
      </v-row>
    </v-card-text>
  </v-container>
</template>

<script>
// Api
import { Api } from '@/api/apiAccess.ts';


export default {
  name: 'NotFound',

  data() {
    return {
      clubNumOrigin: undefined,
      clubNumToRetry: undefined,
      retryButtonLoading: false,
      lastClubNum: null,
      lastClubName: null,
      showLastClubNumDialog: false,
      loading: false,
    };
  },

  methods: {
    isMobile() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))
        return true;
      return false;
    },

    clubNumNotFound() {
      return {
        message: this.$t("error.clubNumNotFound"),
        color: "error",
        icon: "mdi-numeric-off",
        timeout: 2500,
      }
    },
    clubNumFound(clubNum) {
      return {
        message: this.$t("common.clubNumFound", [clubNum]),
        color: "success",
        icon: "mdi-numeric",
        timeout: 2500,
      }
    },

    async checkNewClubNum(clubNumToCheck) {
      if (this.clubNumToRetry == undefined || this.clubNumToRetry <= 0) return;

      this.retryButtonLoading = true;
      var clubLoginViewModel = { VereinsNummer: clubNumToCheck, Passwort: 'interessiert nicht', CvpSecret: 'interessiert noch weniger' };
      var clubNumberExists = (await Api.HaKuBu.haKuBuVereinsLogin(clubLoginViewModel)).data.LoginId != -2;

      // Before forwarding to the login page, check whether the newly entered club number can be assigned to a club
      if (!clubNumberExists) {
        this.clubNumOrigin = clubNumToCheck;
        this.clubNumToRetry = clubNumToCheck;
        this.$root.snackbar.show(this.clubNumNotFound(clubNumToCheck));
        this.retryButtonLoading = false;
        return;
      }

      var routeToLogin = this.$router.resolve({ name: 'RegistrationMain', params: { clubNumber: clubNumToCheck } }).href;
      this.$root.snackbar.show(this.clubNumFound(clubNumToCheck));

      // wait 1.5 seconds until the snackbar has disappeared
      setTimeout(() => {
        this.retryButtonLoading = false;
        window.location = routeToLogin;
      }, 1500);
    },
  },
};
</script>

<style>
.not-found {
  /* behavior */
  font-size: 64px;
  font-weight: bold;
}
</style>
